'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFetched = isFetched;
exports.fetchImage = fetchImage;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetched = {};

function isFetched(src) {
  return fetched[src];
}

function fetchImage(src) {
  if (isFetched(src)) {
    return _q2.default.Promise.resolve();
  }

  return new _q2.default.Promise(function (resolve, reject) {
    var img = new Image();
    var onload = function onload() {
      fetched[src] = true;
      resolve();
    };
    img.onerror = reject;
    img.onload = onload;
    img.src = src;
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.1456/js/lib/Image.js
// module id = 487
// module chunks = 171